import { render, staticRenderFns } from "./OrderMessagesModal.vue?vue&type=template&id=267e725a&scoped=true&"
import script from "./OrderMessagesModal.vue?vue&type=script&lang=js&"
export * from "./OrderMessagesModal.vue?vue&type=script&lang=js&"
import style0 from "./OrderMessagesModal.vue?vue&type=style&index=0&id=267e725a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267e725a",
  null
  
)

export default component.exports